import { setTrackingId } from "client/Misc/utils";
import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { FormattedText } from "../FormattedText/FormattedText";

export type PageInfoProps = {
	firstItemIndex: number;
	lastItemIndex: number;
	totalAmountOfItems: number;
	trackingId?: string;
};

export const PageInfo = (props: PageInfoProps): ReactElement => {
	const {
		firstItemIndex,
		lastItemIndex,
		totalAmountOfItems,
		trackingId
	} = props;
	return (
		<div
			{...setTrackingId(trackingId)}
			aria-live="polite"
			aria-atomic="true"
		>
			<FormattedText
				text={localize("_AmountOfTotalItems")}
				thingsToReplace={[
					{
						what: "{{Amount}}",
						filler: firstItemIndex === lastItemIndex
							? `${firstItemIndex + 1}`
							: `${firstItemIndex + 1} - ${lastItemIndex + 1}`
					},
					{what: "{{Total}}", filler: totalAmountOfItems.toString()}
				]}
			/>
		</div>
	);
};

PageInfo.displayName = "PageInfo";
